import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { getPolicyDocumentStats } from '../../../services/policyService';

const Container = styled.div``;

const CardsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
`;

const StatCard = styled.div`
  background: #fff;
  border-radius: 6px;
  padding: 20px;
  box-shadow: 0 1px 4px rgba(0, 66, 66, 0.06);
  text-align: center;
`;

const StatValue = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: ${({ $color }) => $color || '#004242'};
  margin-bottom: 4px;
`;

const StatLabel = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #A0A8B4;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 6px;
  padding: 24px;
  box-shadow: 0 1px 4px rgba(0, 66, 66, 0.06);
`;

const ProgressBarContainer = styled.div`
  background: #E0E4E8;
  border-radius: 4px;
  height: 24px;
  overflow: hidden;
  margin-top: 12px;
`;

const ProgressBarFill = styled.div`
  height: 100%;
  border-radius: 4px;
  background: ${({ $color }) => $color || '#16a34a'};
  transition: width 0.4s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
`;

const ProgressLabel = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #004242;
`;

export default function StatsTab({ documentId }) {
  const { t } = useTranslation();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    getPolicyDocumentStats(documentId)
      .then((res) => setStats(res.data?.data));
  }, [documentId]);

  if (!stats) return null;

  const total = stats.totalAssigned || 0;
  const completed = stats.completed || 0;
  const pending = stats.pending || 0;
  const overdue = stats.overdue || 0;
  const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <Container>
      <CardsRow>
        <StatCard>
          <StatValue>{total}</StatValue>
          <StatLabel>{t('policy.totalAssigned')}</StatLabel>
        </StatCard>
        <StatCard>
          <StatValue $color="#16a34a">{completed}</StatValue>
          <StatLabel>{t('policy.completedCount')}</StatLabel>
        </StatCard>
        <StatCard>
          <StatValue $color="#ca8a04">{pending}</StatValue>
          <StatLabel>{t('policy.pendingCount')}</StatLabel>
        </StatCard>
        <StatCard>
          <StatValue $color="#ef4444">{overdue}</StatValue>
          <StatLabel>{t('policy.overdueCount')}</StatLabel>
        </StatCard>
      </CardsRow>

      <Card>
        <ProgressLabel>{t('policy.completionRate')}: {percentage}%</ProgressLabel>
        <ProgressBarContainer>
          <ProgressBarFill
            style={{ width: `${percentage}%` }}
            $color={percentage >= 80 ? '#16a34a' : percentage >= 50 ? '#ca8a04' : '#ef4444'}
          >
            {percentage > 10 ? `${percentage}%` : ''}
          </ProgressBarFill>
        </ProgressBarContainer>
      </Card>
    </Container>
  );
}
